module.exports = __webpack_public_path__ + "static/img/leader1.f68986f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/leader1.png
// module id = szuZ
// module chunks = 1